import { useCallback, useRef, type MutableRefObject } from 'react';

export interface RenameFieldRef {
  renameButtonRef: MutableRefObject<HTMLButtonElement | null>;
  renameInputFieldRef: MutableRefObject<HTMLInputElement | null>;
}

export function useRenameField() {
  const renameFieldRef = useRef<RenameFieldRef>(null);

  const showRenameInputField = useCallback(() => {
    if (!renameFieldRef.current) return;

    const element = renameFieldRef.current?.renameButtonRef.current;

    if (!element) return;

    element.dispatchEvent(
      new MouseEvent('dblclick', {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    );
  }, []);

  return { renameFieldRef, showRenameInputField };
}
